import React from 'react'

import { Switch, Route } from 'react-router-dom'

import { RATEANDREVIEWS_ROUTES } from 'App/constants'

import UnreviewedProductsComponent from './UnreviewedProducts'

const UnreviewedProducts: React.FC = () => (
  <Switch>
    <Route
      exact
      path={RATEANDREVIEWS_ROUTES.UnreviewedProductsPage.path}
      component={UnreviewedProductsComponent}
    />
  </Switch>
)

export default UnreviewedProducts
